import { useQuery } from "@tanstack/react-query";

import { getPartnersPartnerID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "./queryKeys";

export function usePartnerDetailQuery(partnerID?: string) {
  return useQuery({
    queryKey: PARTNERS_QUERY_KEYS.detail(partnerID!),
    queryFn: processResponse(() => getPartnersPartnerID(partnerID!)),
    enabled: !!partnerID,
  });
}
